import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import styles from '../styles';
import FirstSection from './FirstSection';
import SecondSection from './SecondSection';
import ThirdSection from './ThirdSection';
import FourthSection from './FourthSection';
import FifthSection from './FifthSection';
import ServicesComments from './ServicesComments';

const EscalatorControlList = props => {
  return (
    <View style={styles.table}>
      <View style={styles.row}>
        <View style={[styles.width35, styles.sectionHeader, styles.noBorder]}>
          <Text style={[styles.text, styles.center]}>PIKAT E KONTROLLIT</Text>
        </View>
        <View
          style={[
            styles.width65,
            styles.sectionHeader,
            styles.noBorder,
            styles.borderLeft,
          ]}>
          <Text style={styles.text}>KONTROLLOHET</Text>
        </View>
      </View>
      <FirstSection {...props} />
      <SecondSection {...props} />
      <ThirdSection {...props} />
      <FourthSection {...props} />
      <FifthSection {...props} />
      <ServicesComments />
    </View>
  );
};

export default EscalatorControlList;
